<template>
    <div>
        <v-card flat>
            <v-toolbar color="#303a55" dark extended flat>
            </v-toolbar>
            <v-card class="mx-auto pa-4" max-width="700" style="margin-top: -64px;">
                <v-img :src="require('./../assets/VULlogo.png')" width="100" height="100" class="mx-auto">
                </v-img>
                <v-card-title class="justify-center">Welcome to VUL</v-card-title>
                <v-card-subtitle class="text-center">FEE PAYMENT GATEWAY</v-card-subtitle>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid" ref="form">
                            <v-text-field label="First Name" outlined color="#303a55" dense v-model="firstname" :rules="firstnameRules">
                            </v-text-field>
                            <v-text-field label="Last Name" outlined color="#303a55" class="mt-2" dense v-model="lastname" :rules="lastnameRules">
                            </v-text-field>
                            <v-text-field label="Email Address" outlined color="#303a55" class="mt-2" dense v-model="emailid" :rules="emailRules" required>
                            </v-text-field>
                            <label for="" class="mt-2">Choose Payment Plan</label>
                            <v-radio-group v-model="row" column :rules="paymentOptionRules" class="mb-2" @change="updateAmount">
                                <v-radio label="$1250 per month" value="monthly"></v-radio>
                                <v-radio label="$5000 per semester (lump-sum)" value="semester"></v-radio>
                                <v-radio label="Other" value="other"></v-radio>
                            </v-radio-group>
                            <v-text-field label="Amount" outlined dense color="#303a55" v-model="amount" :rules="amtRules" :readonly="readonlyAmt">
                            </v-text-field>
                            <v-text-field label="Address Line" dense outlined color="#303a55" v-model="address" :rules="addressRules">
                            </v-text-field>
                            <v-text-field label="City" dense outlined color="#303a55" v-model="city" :rules="cityRules" class="mt-2">
                            </v-text-field>
                            <v-row>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <v-text-field label="State" dense outlined color="#303a55" v-model="state" :rules="stateRules" class="mt-2"></v-text-field>
                                </v-col>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <v-text-field label="ZIP Code" dense outlined color="#303a55" v-model="zipcode" :rules="zipcodeRules" class="mt-2"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field label="Name on Card" outlined dense color="#303a55" v-model="cardName" :rules="cardNameRules" class="mt-4">
                            </v-text-field>
                        </v-form>
                        <div id="form-container">
                            <div id="sq-card-number"></div>
                            <div class="third" id="sq-expiration-date"></div>
                            <div class="third" id="sq-cvv"></div>
                            <div class="third" id="sq-postal-code"></div>
                            <v-text-field label="Comments" style="display: block;" v-model="comments" outlined dense color="#303a55" class="mt-8"></v-text-field>
                            <v-form v-model="valid1" ref="form1">
                                <v-checkbox v-model="disclaimer" style="display:block;" :rules="disclaimerRules" label=" I hereby Authorize to charge my credit card with the above mentioned amount on recurring basis and confirm that the information for the credit card and billing address is complete and accurate">
                                </v-checkbox>
                            </v-form>
                            <button id="sq-creditcard" class="button-credit-card mt-4" @click="onGetCardNonce($event)">Submit</button>
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-card> 
        <Loading :loading="loading"></Loading>
        <PrimarySuccess :message="{modal: modal, text: message}"></PrimarySuccess>
        <snackbar :snackbar.sync="snackbar" :message.sync="snackbarMessage" v-on:closeSnackbar="closeSnackbar"></snackbar>
    </div>
</template>
<script type="text/javascript" src="https://js.squareup.com/v2/paymentform"></script>
<script>
    import {FeeService} from './../services/FeeService.js';
    import Loading from './Loading.vue';
    import Snackbar from './Snackbar.vue';
    import PrimarySuccess from './PrimarySuccess.vue';
    export default{
        data(){
            return{
                paymentForm: null,
                firstname: '',
                lastname: '',
                emailid: '',
                address: '',
                city: '',
                state: '',
                zipcode: '',
                amount: '',
                disclaimer: false,
                readonlyAmt: true,
                comments: '',
                cardName: '',
                row: '',
                firstnameRules: [
                    v => !!v || 'Firstname is required'
                ],
                lastnameRules: [
                    v => !!v || 'Lastname is required'
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                cardNameRules: [
                    v => !!v || 'Card holder name is required'
                ],
                addressRules: [
                    v => !!v || 'Address line is required'
                ],
                cityRules: [
                    v => !!v || 'City is required'
                ],
                stateRules: [
                    v => !!v || 'State is required',
                ],  
                zipcodeRules: [
                    v => !!v || 'Zip Code is required'
                ],
                disclaimerRules: [
                    v => !!v || 'This is required'
                ],
                paymentOptionRules: [
                    v => !!v || 'Please choose a payment option'
                ],
                amtRules: [
                    v => !!v || 'Please enter a valid amount'
                ],
                message: '', // model for showing message in dialog box
                modal: false, // model for showing dialog box
                loading: false, // model for showing loading sign
                valid: false, //model for form1
                valid1: false, //model for form2
                snackbar: false, //model for showing snackbar
                snackbarMessage: '' // model for passing snackbar message
            }
        },
        components:{
            Loading,
            PrimarySuccess,
            Snackbar
        },
        methods:{
            onGetCardNonce: function(event) {
                event.preventDefault();
                if(this.$refs.form.validate() && this.$refs.form1.validate()){
                    this.loading = true;
                    this.paymentForm.requestCardNonce();    
                }
                else{
                    this.snackbar = true;
                    this.snackbarMessage = "Please fill in the details";
                }
            },
            updateAmount(){
                if(this.row == 'monthly'){
                    this.amount = '1250';
                    this.readonlyAmt = true;
                }
                else if(this.row == 'semester'){
                    this.amount = '5000';
                    this.readonlyAmt = true;
                }
                else if(this.row == 'other'){
                    this.amount = '';
                    this.readonlyAmt = false;
                }
            },
            closeSnackbar(value){
                this.snackbar=value;
            },
        },
        mounted(){
            this.paymentForm = new SqPaymentForm({
                applicationId: "sq0idp-dGDRMTwAyoSQnPoS4OlSxA",        
                inputClass: 'sq-input',
                autoBuild: false,
                inputStyles: [{
                fontSize: '16px',
                lineHeight: '16px',
                padding: '12px',
                placeholderColor: '#9d9e9f',
                backgroundColor: '#ffffff'
                }],
                cardNumber: {
                elementId: 'sq-card-number',
                placeholder: 'Card Number'
                },
                cvv: {
                elementId: 'sq-cvv',
                placeholder: 'CVV'
                },
                expirationDate: {
                elementId: 'sq-expiration-date',
                placeholder: 'MM/YY'
                },
                postalCode: {
                elementId: 'sq-postal-code',
                placeholder: 'Postal'
                },
                callbacks: {
                    cardNonceResponseReceived: (errors, nonce, cardData) => {
                        if (errors) {
                            errors.forEach(function (error) {
                                console.error('  ' + error.message);
                            });
                            this.loading = false;
                            this.snackbar = true;
                            // console.log(errors);
                            this.snackbarMessage = errors[0].message;
                            // alert('Encountered errors, check browser developer console for more details');
                            return;   
                        }
                        // console.log(nonce);
                        // console.log(cardData);
                        // alert(`The generated nonce is:\n${nonce}`);
                        FeeService.squareupPay({
                            nonce: nonce,
                            firstname: this.firstname,
                            lastname: this.lastname,
                            amount: this.amount,
                            addressline: this.address,
                            city: this.city,
                            state: this.state,
                            zipcode: this.zipcode,
                            comments: this.comments,
                            cardholdername: this.cardName,
                            paymentOption: this.row,
                            emailid: this.emailid
                        }).then((response) => {
                            this.loading = false;
                            this.modal = true;
                            this.message = "Thank you for submitting the form"
                            console.log(response);
                        }).catch((error) => {
                            this.loading = false;
                            this.modal = true;
                            this.message = "Oops! Something went wrong. Please try again."
                            console.log(error);
                        });
                    }
                }
            });
            this.paymentForm.build();
        }
    }
</script>

<style>
    * {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body, html {
        background-color: #F7F8F9;
        color: #373F4A;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: normal;
        height: 100%;
    }

    button {
        border: 0;
        font-weight: 500;
    }

    fieldset {
        margin: 0;
        padding: 0;
        border: 0;
    }

    #form-container {
        position: relative;
        width: 100%;
        margin: 0 auto;
        top: 50%;
        transform: translateY(-50%);
        margin-top: 34%;
    }

    .third {
        float: left;
        width: calc((100% - 32px) / 3);
        padding: 0;
        margin: 0 16px 16px 0;
    }

    .third:last-of-type {
        margin-right: 0;
    }

    /* Define how SqPaymentForm iframes should look */
    .sq-input {
        height: 45px;
        box-sizing: border-box;
        border: 1px solid #9d9e9f;
        background-color: white;
        border-radius: 6px;
        display: inline-block;
        -webkit-transition: border-color .2s ease-in-out;
            -moz-transition: border-color .2s ease-in-out;
            -ms-transition: border-color .2s ease-in-out;
                transition: border-color .2s ease-in-out;
    }

    /* Define how SqPaymentForm iframes should look when they have focus */
    .sq-input--focus {
        border: 1px solid #4A90E2;
    }

    /* Define how SqPaymentForm iframes should look when they contain invalid values */
    .sq-input--error {
        border: 1px solid #E02F2F;
    }

    #sq-card-number {
        margin-bottom: 16px;
    }

    /* Customize the "Pay with Credit Card" button */
    .button-credit-card {
        width: 100%;
        height: 48px;
        margin-top: 72px;
        background: #303A55;
        border-radius: 6px;
        cursor: pointer;
        display: block;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        letter-spacing: 0;
        text-align: center;
        -webkit-transition: background .2s ease-in-out;
            -moz-transition: background .2s ease-in-out;
            -ms-transition: background .2s ease-in-out;
                transition: background .2s ease-in-out;
    }

    .button-credit-card:hover {
        background-color: #4281CB;
    }

</style>